import { type RouteObject } from 'react-router';

export const routes: RouteObject[] = [
    {
        path: '',
        lazy: async () => {
            const { Layout } = await import('@@routes/tags');

            return { Component: Layout };
        },
        children: [
            {
                path: ':id',
                lazy: async () => {
                    const { default: TagForm } = await import('@@routes/tags/TagForm');

                    return { Component: TagForm };
                },
            },
        ],
    },
];
